//const API_BASE = "http://localhost:8000";
const API_BASE = "http://50.6.227.192:8080";

export async function getSchema() {
  const res = await fetch(`${API_BASE}/schema`);
  if (!res.ok) throw new Error("Failed to load schema");
  return res.json();
}

export async function chatMessage(message) {
  const res = await fetch(`${API_BASE}/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.detail || "Chat failed");
  return data;
}
